module.exports = __webpack_public_path__ + "static/media/MoP_logo_no_baseline.8b62dc35.svg";